import { useEffect,useState } from 'react';

/**
 * @param  {number} totalJobCards Provide number of total dependent job cards which priority like if totalJobCards=3 then priority will be 1,2,3
 * @returns [] Returns instances priority wise
 */
export const useDependedJobList = (totalJobCards) => {
  const [fetchedJobLists, setJobLists] = useState({});

  useEffect(() => {
    let list = {};
    for (let i = 1; i <= totalJobCards; i++) {
      list[i] = { isLoading: true, storedData: { listingHashes: [] } };
    }
    setJobLists(list);
  }, []);

  const onJobsFetched = (priorityId, jobs) => {
    if (priorityId) {
      const jobList = fetchedJobLists[priorityId];
      if (jobList) {
        let updatedJobList = {
          ...jobList,
          isLoading: false,
          storedData: {
            ...(jobList?.storedData ?? {}),
            listingHashes: jobs.map((x) => x.listingHash),
          },
        };
        setJobLists({ ...fetchedJobLists, [priorityId]: updatedJobList });
      }
    }
  };

  const getListingHashesById = (priorityId) => {
    if (fetchedJobLists.hasOwnProperty(priorityId)) {
      return Object.keys(fetchedJobLists)
        .filter((key) => parseInt(key) < priorityId && fetchedJobLists[key]['storedData'])
        .reduce((occ, key) => [...occ, ...fetchedJobLists[key]['storedData']['listingHashes']], []);
    } else return [];
  };

  const shallIGo = (priorityId) => {
    return !Object.entries(fetchedJobLists)
      .filter(([id]) => parseInt(id) < parseInt(priorityId))
      .some(([id, { isLoading }]) => isLoading === true);
  };

  const ifHidden = (id) => {
    if (fetchedJobLists[id].isLoading) {
      const items = { ...fetchedJobLists };
      items[id].isLoading = false;
      setJobLists(items);
    }
  };

  return Object.entries(fetchedJobLists)
    .sort(([idA], [idB]) => parseInt(idA) - parseInt(idB))
    .map(([id, self]) => ({
      priorityId: parseInt(id),
      previousListingHashes: getListingHashesById(id),
      onJobsFetched: (jobs) => onJobsFetched(id, jobs),
      fetchedAllJobLists: fetchedJobLists,
      shallIGo: shallIGo(id),
      ifHidden: () => ifHidden(id),
      self,
    }));
};

export function UseDependedJobListWrapper({ totalJobCards, children, renderConditions = [] }) {
  let instances = useDependedJobList(totalJobCards);

  renderConditions.forEach((condition, index) => {
    if (condition) instances[index]?.ifHidden();
  });

  return children(instances);
}
